import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    CreateWarehouseCardMutationVariables,
    refetchPaginatedStockCardsQuery,
    useCreateWarehouseCardMutation,
} from '../../../../generated/graphql';
import { useWarehousesScope } from '../../providers/WarehouseScopeProvider';
import { LocationReferrer } from '../../../../types/locationReferrer';
import { routePaths } from '../../../../routePaths';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { WarehouseCardFormValues } from './types';
import WarehouseCardForm from './WarehouseCardsForm';
import { WAREHOUSE_CARDS_ROWS_PER_PAGE } from './constants';
import { getPriceUpdateArgs } from './utils';

const CreateWarehouseCardForm = () => {
    const { currentWarehouseId } = useWarehousesScope();
    const { priceService } = usePriceService();
    const [runMutation] = useCreateWarehouseCardMutation({
        refetchQueries: [ refetchPaginatedStockCardsQuery(
            { offset: 0, limit: WAREHOUSE_CARDS_ROWS_PER_PAGE, warehouseIds: [currentWarehouseId as string] }
        )]
    });

    const history = useHistory<LocationReferrer>();
    const { state = {} } = history.location;
    const { referrer } = state;
    const handleClose = () => {
        history.push(referrer || routePaths.warehouseCards);
    };

    const onSubmit = async ({
        name,
        warehouseIds,
        categoryId,
        convertedQuanitity,
        convertedUnit,
        storageUnitId: storagUnitId,
        taxId,
        sku,
        priceWithoutVat,
    }: WarehouseCardFormValues) => {
        const priceUpdateArgs = getPriceUpdateArgs({ priceWithoutVat, warehouseIds, priceService });

        const variables: CreateWarehouseCardMutationVariables = {
            data: {
                name,
                sku,
                taxId,
                warehouseIds,
                storageUnit: storagUnitId,
                convertedAmount: convertedQuanitity ? parseFloat(convertedQuanitity.toString()) : null,
                conversionUnit: convertedUnit,
                stockCardCategoryId: categoryId,
            },
            priceUpdateArgs,
        };

        await runMutation({ variables });
    };

    const { t } = useTranslation();
    const buttonText = t('Create');
    const dialogName = t('New warehouse card');


    return (
        <WarehouseCardForm
            buttonText={buttonText}
            dialogName={dialogName}
            onSubmit={onSubmit}
            onClose={handleClose}
            currentWarehouseId={currentWarehouseId as string}
        />
    );
};

export default CreateWarehouseCardForm;
